<script setup>
import { defineProps } from "vue"
import Meta from "./Meta.vue"
import BreadCrumbs from "./BreadCrumbs.vue"
import Card from "@common/js/components/cards/content/ContentVerticalSplitCard.vue"

// props
const props = defineProps({
  references: {
    type: Array,
    required: true,
  },
})

function getRouterLink(entry) {
  const entryTags = entry.metadata.tags.map((o) => o.sys.id)
  if (entryTags.includes("blogArticle"))
    return { name: "BlogArticle", params: { slug: entry.fields.slug } }
  else if (entryTags.includes("installerAccountGuide"))
    return {
      name: "HelpGuideInstallerYourAccountArticle",
      params: { slug: entry.fields.slug },
    }
  else if (entryTags.includes("installerPresentationGuide"))
    return {
      name: "HelpGuideInstallerPresentationArticle",
      params: { slug: entry.fields.slug },
    }
  else if (entryTags.includes("installerQuotingGuide"))
    return {
      name: "HelpGuideInstallerQuotingArticle",
      params: { slug: entry.fields.slug },
    }
  else if (entryTags.includes("installerHardwareGuide"))
    return {
      name: "HelpGuideInstallerHardwareArticle",
      params: { slug: entry.fields.slug },
    }
  else if (entryTags.includes("installerAdministrationGuide"))
    return {
      name: "HelpGuideInstallerAdministrationArticle",
      params: { slug: entry.fields.slug },
    }
  else if (entryTags.includes("installerPaymentsGuide"))
    return {
      name: "HelpGuideInstallerPaymentsArticle",
      params: { slug: entry.fields.slug },
    }
  else if (entryTags.includes("installerProjectManagementGuide"))
    return {
      name: "HelpGuideInstallerProjectManagementArticle",
      params: { slug: entry.fields.slug },
    }
  else if (entryTags.includes("installerPostInstallationGuide"))
    return {
      name: "HelpGuideInstallerPostInstallationArticle",
      params: { slug: entry.fields.slug },
    }
  else if (entryTags.includes("installerLegalGuide"))
    return {
      name: "HelpGuideInstallerLegalArticle",
      params: { slug: entry.fields.slug },
    }
  else
    return {
      to: { name: "BlogSeries" },
    }
}
</script>

<template>
  <!-- Related content -->
  <div class="mt-8">
    <h3 class="h3 mb-8">{{ $t("common.pagination.table.related") }}</h3>
    <div class="flex gap-4 justify-between items-center">
      <router-link
        v-for="reference in references"
        :key="reference.sys.id"
        class="rounded border border-gray-200 transition duration-300 ease-in-out bg-white shadow-md hover:shadow-lg"
        :to="getRouterLink(reference)"
      >
        <Card :entry="reference" :has-router-link="true" />
      </router-link>
    </div>
  </div>
</template>
